export default {"src":"/_next/static/media/check.e08f44ed.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};